function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return '';
  }
}

export default function HistorySidebar({ history, activeId, onPick, onDelete, onNew, onClose }) {
  return (
    <div className="bg-base-200 rounded-lg h-full flex flex-col">
      <div className="flex items-center justify-between p-2 border-b border-base-300">
        <h3 className="font-bold text-sm">History</h3>
        <div className="flex gap-1">
          <button className="btn btn-xs btn-primary" onClick={onNew} title="New challan">
            + New
          </button>
          <button className="btn btn-xs btn-ghost" onClick={onClose} title="Hide history">
            ✕
          </button>
        </div>
      </div>

      {history.length === 0 ? (
        <div className="p-3 text-xs opacity-60">
          Generated challans will appear here.
        </div>
      ) : (
        <ul className="overflow-auto flex-1 p-1">
          {history.map((e) => (
            <li
              key={e.id}
              className={`group rounded p-2 cursor-pointer text-sm hover:bg-base-300 ${
                activeId === e.id ? 'bg-base-300' : ''
              }`}
              onClick={() => onPick(e)}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs opacity-70">#{e.challanNo}</span>
                <button
                  className="btn btn-xs btn-ghost opacity-0 group-hover:opacity-100"
                  onClick={(ev) => { ev.stopPropagation(); onDelete(e.id); }}
                  title="Remove from history"
                >
                  ✕
                </button>
              </div>
              <div className="truncate font-medium">{e.customerName}</div>
              <div className="flex items-center justify-between text-xs opacity-60">
                <span>{e.dateStr}</span>
                <span>qty {e.total}</span>
              </div>
              <div className="text-[10px] opacity-50">{formatDate(e.generatedAt)}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
